export const SIDE = {
	left: 'left',
	top: 'top',
	right: 'right',
	bottom: 'bottom',
	leftTop: 'leftTop',
	leftBottom: 'leftBottom',
	rightBottom: 'rightBottom',
	rightTop: 'rightTop',
	region: 'region',
} as const;

export const SUPPORTED_PROP = {
	size: 'size',
	position: 'position',
	padding: 'padding', // currently unused
} as const;
